import { addDays, subDays } from "date-fns";
import { useActivitiesList } from "web_myplann/Activities/Hooks/useActivitiesList";
import {
	dateFormatter,
	ISO_DATE_FORMAT,
} from "web_myplann/Shared/Utils/dateFormatters";

const UPCOMING_WINDOW_DAYS = 30;
const OVERDUE_WINDOW_DAYS = 14;

export const useDashboardActivities = (pageSize?: number) => {
	const currentDate = new Date();

	return useActivitiesList({
		upcomingUntil: dateFormatter(
			addDays(currentDate, UPCOMING_WINDOW_DAYS),
			ISO_DATE_FORMAT,
		),
		overdueFrom: dateFormatter(
			subDays(currentDate, OVERDUE_WINDOW_DAYS),
			ISO_DATE_FORMAT,
		),
		includeResolvedEvents: false,
		pageSize,
	});
};
